services.service('VerificationV2Service', [
    'UserService', '$state', 'constants', 'API', 'Utils', 'ErrorService', 'DocumentV2Model', 'BaseCollection', 'Storage', '$q',
    function (UserService, $state, Const, API, Utils, ErrorService, DocumentV2Model, BaseCollection, Storage, $q) {
        var self = this;

        self.collection = new BaseCollection();


        this.init = function () {
            var user = UserService.get();

            if (!user.loggedIn) {
                return $q.resolve();
            }
            if (Const["verificationProvider"] !== 'internal-v2') {
                return $q.resolve();
            }
            self.collection.clear()

            return API.documentsGet()
                .then(checkResponse)
                .then(function (response) {
                    var documents = response.documentsRequired.map(function (item) {
                        return initDocument(item)
                    })
                    self.collection.fill(documents)
                    Storage.set('verification', self.collection.find({status: 'New'}).length > 0);
                })
                .catch(function (error) {
                    console.warn('Failed to retrieve documents', error);
                })
        }

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'VerificationV2Service',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function initDocument(rawDocument) {
            return new DocumentV2Model(rawDocument)
        }
    }
])
